import { withI18n } from 'panda-i18n';
import locale from '@/locales';
import { CnEmployeeSelect as UICnEmploySelect } from './employee-select';
import './styles/index.scss';
export var CnEmployeeSelect = withI18n(UICnEmploySelect, { locale: locale });
